// i18n strings shared by the `components/lists/*` family — entry points are
// AddToListButton (popover trigger on comic/release detail surfaces),
// SearchableMultiSelect (the multi-select inside that popover), CreateListForm
// (the inline create-list form rendered in popover create mode), and the
// useListMutations hook (toasts on mutation success/error). Shelf and detail-
// pane copy lives in screens/shelf/i18n.ts — this file is the dual home for
// the component-level surfaces only.
export const lists = {
  addToList: {
    // Popover trigger
    triggerLabel: "Add to Lists",
    // Popover / Drawer header
    header: "Add to lists",
    // Popover footer actions
    newList: "New List +",
    cancel: "Cancel",
    backToLists: "Back",
    // Apply button — pluralised based on total pending changes (adds+removes)
    applyChanges_one: "Apply ({{count}})",
    applyChanges_other: "Apply ({{count}})",
    applyNoChanges: "Apply",
    // Toasts on Apply (multi-list add/remove)
    noListsSelectedTitle: "Nothing to change",
    noListsSelectedDescription: "Toggle a list to add or remove this item.",
    addError: "Failed to add to lists",
    // Toasts on create-and-add
    createSuccessTitle: "List created successfully",
    createSuccessDescription: '"{{name}}" has been created.',
    createAndAddSuccessTitle: "List created and entity added",
    createAndAddSuccessDescription:
      '"{{name}}" has been created and the {{entityType}} was added to it.',
    createAndAddPartialTitle: "List created but failed to add entity",
    createAndAddPartialDescription:
      "\"{{name}}\" was created, but the {{entityType}} couldn't be added automatically.",
    createError: "Failed to create list",
    genericErrorFallback: "Something went wrong",
    // Entity-type words used in the create-and-add toasts above.
    entityTypeComic: "comic",
    entityTypeRelease: "release",
  },
  searchableMultiSelect: {
    searchPlaceholder: "Search lists...",
    noResults: "No lists found",
    noListsCreatedYet: "No lists created yet",
    // Shown next to lists the entity is already a member of, in the unified
    // checkbox model (the row's checkbox is checked initially; unchecking it
    // queues a remove). Quiet "In list" rather than the destructive "Remove"
    // language of the old explicit X button — destructiveness is implicit in
    // the uncheck gesture itself.
    inListBadge: "In list",
    // Aria label for the lock indicator rendered next to private lists.
    privateAria: "Private list",
    // Per-row meta line — item count. Distinct keys per kind so the
    // wording stays accurate even when the same noun would pluralise
    // differently in another language (where comicCount + releaseCount
    // need different stems).
    statComics_one: "{{count}} series",
    statComics_other: "{{count}} series",
    statReleases_one: "{{count}} chapter",
    statReleases_other: "{{count}} chapters",
  },
  createListForm: {
    title: "Create new {{kind}} list",
    kindComic: "comic",
    kindRelease: "release",
    nameLabel: "List Name",
    namePlaceholder: "Enter list name...",
    descriptionLabel: "Description (Optional)",
    descriptionPlaceholder: "Enter description...",
    cancel: "Cancel",
    submit: "Create List",
    // Privacy switch — wording mirrors the shelf wizard's step-3 copy so
    // the inline form here and the full wizard read identically.
    privacyPublicLabel: "Public",
    privacyPublicHelper: "Anyone on GlobalComix can view and save this list",
    privacyPrivateLabel: "Private",
    privacyPrivateHelper: "Only you can see this list",
  },
};
